export const kpiDataTypes = [
  [1, 'number'],
  [2, 'percentage'],
  [3, 'currency'],
];
export const kpiTypeMap = new Map(kpiDataTypes);
